import { Skeleton } from "@/components/ui/adapters";
import React, { type FC } from "react";

const ConversationsItem: FC = () => {
  return (
    <div className="flex items-center justify-between px-4 h-[72px]">
      <div className="flex flex-row gap-4 items-center">
        <Skeleton className="rounded-full size-12" />
        <div>
          <Skeleton className="rounded-md w-24 h-4 mb-2" />
          <Skeleton className="rounded-md w-32 h-3" />
        </div>
      </div>
      <div className="h-10 flex justify-end items-start">
        <Skeleton className="h-4 w-20 rounded-md" />
      </div>
    </div>
  );
};

export default ConversationsItem;
